import { render, staticRenderFns } from "./WorkspaceSelectionModal.vue?vue&type=template&id=350e1fcb&scoped=true&"
import script from "./WorkspaceSelectionModal.vue?vue&type=script&lang=js&"
export * from "./WorkspaceSelectionModal.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceSelectionModal.vue?vue&type=style&index=0&id=350e1fcb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350e1fcb",
  null
  
)

export default component.exports